import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Icon",
  icon: "forms",
  tags: ["#icon"],
}

export default defineBlock("content/icon", (props) => {
  return (
    <div className="inline-flex m-0 aspect-square items-center justify-center rounded-md bg-bg-low size-8 relative">
      <div className="absolute inset-2">
        <ResponsiveImage {...props.image} max objectFit="contain" />
      </div>
    </div>
  )
})
